import ApiService from '../apiService';

export default {
  async evaluateScript(opts) {
    const params = {
      script: opts.script,
      scriptParams: opts.scriptParams,
    };
    const response = await ApiService.instance.post('/lambda/evaluate', params);
    return response.data;
  },
};
